import { useTranslation } from "react-i18next";

import { Info } from "@/assets/icons/icons";
import { SectionButtonHeader } from "@/components/Interface/SectionButtonHeader/SectionButtonHeader";
import { Tooltip } from "@/components/Interface/Tooltip/Tooltip";
import { ProgressBar } from "@/components/Layout/ProgressBar/ProgressBar";
import { RoamingCallExplanation } from "@/components/Portal/Cockpit/DeviceManagement/Roaming/ShowRoamingOptions/RoamingUsage/RoamingCallExplanation";
import { FCC } from "@/types";

interface Props {
  showRoamingCallExplanation?: boolean;
  isNotAllowedToUse?: boolean;
}

export const RoamingUnlimited: FCC<Props> = ({
  isNotAllowedToUse,
  showRoamingCallExplanation,
}) => {
  const { t } = useTranslation("portal");

  const title = t(
    "cockpit.managementTile.roaming.showOption.active.callsToAndFromAbroad",
  );

  return (
    <section className="mb-4">
      {showRoamingCallExplanation ? (
        isNotAllowedToUse ? (
          <SectionButtonHeader className="mb-4" header={title}>
            <Tooltip
              position="bottom"
              className="right mr-5 mt-4 min-w-[250px] !px-6 !py-4 text-left text-base font-normal text-black sm:mr-6 md:mr-0 md:min-w-[327px]"
              content={
                <p>
                  {t(
                    "cockpit.managementTile.roaming.showOption.active.notAllowedTooltip",
                  )}
                </p>
              }
            >
              <Info className="h-[21px] w-[21px] text-primary-100" />
            </Tooltip>
          </SectionButtonHeader>
        ) : (
          <RoamingCallExplanation title={title} />
        )
      ) : (
        <p className="mb-4 text-base">{title}</p>
      )}

      <ProgressBar />
      <div className="mt-2 block text-base text-primary-100">
        {isNotAllowedToUse ? (
          <span>
            {t("cockpit.managementTile.roaming.showOption.active.notAllowed")}
          </span>
        ) : (
          <span>
            {t(
              "cockpit.managementTile.roaming.showOption.active.unlimitedCalls",
            )}
          </span>
        )}
      </div>
    </section>
  );
};
